import api from '~/services/api';
import {
  CE_ALLOWED_EXTENSIONS,
  CE_MAX_FILE_NAME,
  CE_MAX_FILE_SIZE,
} from '~/ui/constants/communityEngagement';

export const isFile = (value: File | string): value is File => Boolean((value as File)?.name);

export const validateFileType = (file: File, acceptTypes: string): boolean => {
  if (!acceptTypes) return true;

  const type = file?.type;
  if (!type) return false;

  return acceptTypes.split(',').includes(type);
};

export const validateCeDocument = ({ name, size }: File): string | null => {
  const extension = name.includes('.') ? name.split('.').pop()?.toLowerCase() : undefined;
  if (!extension || !CE_ALLOWED_EXTENSIONS.includes(extension)) {
    return `${name}: only JPEG, PNG, HEIC, HEIF and PDF are supported`;
  }
  if (size > CE_MAX_FILE_SIZE) return `${name}: files must be 10MB or smaller`;
  if (name.length > CE_MAX_FILE_NAME) {
    return `${name}: the file name must be ${CE_MAX_FILE_NAME} characters or fewer`;
  }
  return null;
};

export const toPhotoFileName = async (photo: File | string): Promise<string | undefined> => {
  if (isFile(photo)) {
    const formData = new FormData();
    formData.append('file', photo);
    const { data } = await api.file.uploadFile(formData);
    return data.fileName;
  }

  return photo?.split('/').slice(-1).pop();
};
